<div class="block shadow-md lg:hidden">
    <div
        class="relative flex flex-row items-center justify-center border-b border-solid border-black border-opacity-10 py-2 dark:border-contrast-yellow">
        <ion-button class="absolute left-0 mr-1" fill="clear">
            <a class="home-link flex items-center gap-2 text-base text-red-500" [routerLink]="'/home' | localize">
                <ion-icon class="text-xl" name="arrow-back-outline" aria-hidden="true"></ion-icon>
            </a>
        </ion-button>
        <h1 class="var-app-light-dark:font-bold text-center text-base font-semibold leading-5">
            {{ 'ACCESSIBILITY_NOTICE_TITLE' | translate }}
        </h1>
    </div>
    <article class="shared-content" [innerHTML]="'ACCESSIBILITY_NOTICE_HTML' | translate"></article>
</div>

<div class="hidden lg:block">
    <div class="box-border flex w-full bg-white">
        <section class="main-grid mx-auto pb-4">
            <div class="sidebar px-4 text-left">
                <div>
                    <h1 class="align-left mb-10 text-4xl">{{ 'ACCESSIBILITY_NOTICE_TITLE' | translate }}</h1>
                    <hr class="mb-4 h-px border-0 bg-gray-200 dark:bg-contrast-yellow" />
                    <a class="text-default flex items-center gap-2 text-base" [routerLink]="'/home' | localize">
                        <ion-icon class="text-xl" name="arrow-back-outline" aria-hidden="true"></ion-icon>
                        <span>{{ 'LOCAL_BTN_BACK' | translate }}</span>
                    </a>
                    <hr class="mt-4 h-px border-0 bg-gray-200 dark:bg-contrast-yellow" />
                </div>
            </div>
            <article class="shared-content px-4" [innerHTML]="'ACCESSIBILITY_NOTICE_HTML' | translate"></article>
        </section>
    </div>
</div>
